import React, {Component} from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import ReCAPTCHA from 'react-google-recaptcha';

import Validator from '../../common/Validator';
import api from '../../../api/api'

import facebookIcon from "../../../img/ic-facebook.png";
import sendIcon from "../../../img/ic-send-for-button.png";

import styles from "../styles";
import '../../../css/ContactInfusionCenterForm.css';

class ShareLocationForm extends Component {
    constructor (props){
        super(props)
        this.state = {
            fromName: false,
            toName: false,
            toEmail: false,
            message: false,
            captcha: null,
            errors: {}
        }
    }

    onChange = (field, event, value) => {
        this.setState({[field]: value});
    }

    shareOnFacebook = () => {
        let url = "https%3A%2F%2Flocator.infusioncenter.org%2F%23location%2F" + this.props.location.key;
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}&amp;src=sdkpreparse`, "_target=blank");
    }

    onSend = () => {
        let valid = true;
        let validator = new Validator();
        let errors = {};
        let validators = [
            {
                validate: validator.validateNonNull,
                keys: ["fromName", "toName", "toEmail", "message"],
                message: "Please enter a value"
            },
            {
                validate: validator.validateEmail,
                keys: ["toEmail"],
                message: "Please enter a valid email address"
            }
        ];
        validators.forEach((fieldValidator, index) => {
            fieldValidator.keys.forEach((key, keyIndex) => {
                if (!fieldValidator.validate(this.state[key])) {
                    errors[key] = fieldValidator.message;
                    valid = false;
                }
            })
        });
        this.setState({errors: errors});
        if (valid) {
            api.createShareEmail({...this.state, locationId: this.props.location.key})
            this.props.onClose();
        }
    }

    buildTextField(key, hint, floatingLabel, multiLine) {
        return (
            <TextField
                fullWidth={true}
                hintText={hint}
                floatingLabelText={floatingLabel}
                onChange={this.onChange.bind(null, key)}
                errorText={this.state.errors[key]}
                multiLine={multiLine} />
            );
    }

    onCaptchaChange = (value) => {
        this.setState({captcha: value});
    }

    onClose = () => {
        this.setState({captcha: null});
        if (this.props.animateOut) {
            this.props.animateOut();
        } else {
            this.props.onClose();
        }
    }

    render() {
            return (
                <div className="location-details-contact-form-container">
                    <div className="location-details-contact-title">
                        Share {this.props.location.name}
                    </div>
                    <div className="location-details-contact-form-content">
                        <div style={{margin: "20px 0 20px 0"}}>
                            <RaisedButton
                               label="Share on Facebook"
                               primary={true}
                               fullWidth={true}
                               icon={<img src={facebookIcon} alt="facebook icon" />}
                               style={styles.labelStyle}
                               onClick={this.shareOnFacebook}
                             />
                        </div>
                        <div style={{textAlign: "center", marginBottom: "20px"}}>
                            -- or --
                        </div>
                        <div className="location-details-share-via-email-title">Share via Email</div>
                        <div>
                            {this.buildTextField("fromName", "John Doe", "Your Name", false)}
                        </div>
                        <div>
                            {this.buildTextField("toName", "Suzy Q", "To", false)}
                        </div>
                        <div>
                            {this.buildTextField("toEmail", "example@abc.com", "Email Address", false)}
                        </div>
                        <div>
                            {this.buildTextField("message", "Enter a message...", "Your Message", true)}
                        </div>
                        <div style={{marginTop: "20px"}}>
                            <ReCAPTCHA
                                ref="recaptcha"
                                sitekey="6LfNdhsUAAAAAHxU9LqOu2w-ZW5UXmF32Wj37UYh"
                                onChange={this.onCaptchaChange}
                            />
                        </div>
                        <div style={{textAlign: "right", marginTop: "20px"}}>
                            <FlatButton label="Cancel" labelStyle={{color: "#aab4ba"}} style={{marginRight: "15px"}} onTouchTap={this.onClose}/>
                            <FlatButton label="Send" disabled={!this.state.captcha} labelStyle={{color: "white"}} backgroundColor="#53c9e8" icon={<img src={sendIcon} alt="send icon" />} onTouchTap={this.onSend}/>
                        </div>
                    </div>
                </div>
            )
    }
}

export default ShareLocationForm;



// WEBPACK FOOTER //
// ./src/components/locator/details/ShareLocationForm.js